import { Routes } from '@angular/router';
import { HelpComponent } from './help/help.component';
import { NotFoundComponent } from './not-found/not-found.component';
import { RestrictedAccessComponent } from './restricted-access/restricted-access.component';
import { PortalHomeComponent } from './portal-home/portal-home.component';
import { AuthGuard } from '@auth0/auth0-angular';
import { canViewGuard } from '@bioconnect-ui/access-control-service';

export const appRoutes: Routes = [
  {
    path: '',
    data: {breadcrumb: ''},
    component: PortalHomeComponent,
    pathMatch: 'full'
  },
  {
    path: 'portal-home',
    data: {breadcrumb: ''},
    component: PortalHomeComponent
  },
  {
    path: 'file-type',
    data: {breadcrumb: 'File Type Home'},
    loadChildren: () => import('@bioconnect-ui/file-type').then(m => m.FILE_TYPE_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'help',
    data: {breadcrumb: 'Help'},
    component: HelpComponent
  },
  {
    path: 'admin',
    data: {breadcrumb: 'Metadata Admin'},
    loadChildren: () => import('@bioconnect-ui/admin').then(m => m.ADMIN_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'curation',
    data: {breadcrumb: 'Curation Dashboard'},
    loadChildren: () => import('@bioconnect-ui/curation').then(m => m.CURATION_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'protocols',
    data: {breadcrumb: 'Protocols'},
    loadChildren: () => import('@bioconnect-ui/protocols').then(m => m.PROTOCOLS_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'search',
    data: {breadcrumb: 'Search'},
    loadComponent: () => import('@bioconnect-ui/search').then(m => m.MetadataSearchBrowseComponent),
    canActivate: [AuthGuard],
  },
  {
    path: 'view/:type/:id',
    data: {breadcrumb: ''},
    loadComponent: () => import('@bioconnect-ui/reports').then(m => m.DetailViewComponent),
    canActivate: [AuthGuard, canViewGuard],
  },
  {
    // kept for backward compatibility with existing link references
    path: 'search/metadata-search-browse/detail-view/:type/:id',
    redirectTo: '/view/:type/:id'
  },
  {
    // kept for backward compatibility with existing link references
    path: 'search/metadata-search-browse',
    redirectTo: '/search'
  },
  {
    path: 'files',
    data: {breadcrumb: 'Files'},
    loadChildren: () => import('@bioconnect-ui/files').then(m => m.FILES_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'measures',
    data: {breadcrumb: 'Measures'},
    loadChildren: () => import('@bioconnect-ui/measures').then(m => m.MEASURE_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'resources',
    data: {breadcrumb: 'Resources'},
    loadChildren: () => import('@bioconnect-ui/resource').then(m => m.RESOURCE_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'data-packages',
    data: {breadcrumb: 'Data Packages'},
    loadChildren: () => import('@bioconnect-ui/data-packages').then(m => m.DATA_PACKAGE_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'biosamples',
    data: {breadcrumb: ''},
    loadChildren: () => import('@bioconnect-ui/biosample').then(m => m.BIOSAMPLE_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: 'data-schema',
    data: {breadcrumb: 'Data Schema Details'},
    loadChildren: () => import('@bioconnect-ui/data-schema').then(m => m.DATA_SCHEMA_ROUTES),
    canActivate: [AuthGuard],
  },
  {
    path: '404',
    data: {breadcrumb: 'Page Not Found'},
    component: NotFoundComponent,
    pathMatch: 'full'
  },
  {
    path: 'restricted',
    data: {breadcrumb: 'Restricted Access'},
    component: RestrictedAccessComponent,
    pathMatch: 'full'
  },
  { path: '**', redirectTo: '/404' }
];
